import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import "../Details/AboutPage.css";
import AppOffroIcon from "../../media/assets/AppOffroIcon.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import {Button} from "reactstrap";
import AppCercoIcon from "../../media/assets/AppCercoIcon.mjs";
import UserIcon from "../../media/assets/UserIcon.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher/LanguageSwitcher.mjs";
import VSwitch from "../../controls/VSwitch/VSwitch.mjs";

const prefix = 'AboutPage';

const AboutBacheca = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			accepted: Glob.getStatus('bacheca_accepted'),
		};
		this.uid = Glob.generateUid(prefix);
		this.acceptance = this.acceptance.bind(this);
	}
	componentDidMount() {
		Glob.register('Prefs', ()=>{
			const g = Glob.getLanguage();
			if ( g !== this.state.lang ) this.setState({lang:g});
		}, this.uid)
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	acceptance( status ) {
		if ( typeof status === 'undefined' ) status = ! this.state.accepted;
		Glob.setStatus('bacheca_accepted', !! status, true );
		this.setState({ accepted: !! status });
		if ( ! status ) Glob.setCurrentPageParam('pane','about');
	}
	render() {
		return (
			<div
				className={prefix}
				key={this.state.lang}
				lang={this.state.lang}
			>
				<h5 lang={"it"}>Bacheca collaborativa di Oliveto</h5>
				<h5 lang={"en"}>Oliveto Collaborative Noticeboard</h5>
				<p lang={"it"}>
					Area per la collaborazione e la condivisione tra compaesani, così importanti nelle piccole comunità.<br />
					Ok ad annunci locali, anche se non è uno spazio di mercato o di commercio selvaggio.
				</p>
				<p lang={"en"}>
					This area is inspired to collaboration and sharing among fellow villagers, vital elements of small communities.<br />
					Local messages are welcome, even if this isn’t a free market, nor a savage commercial area.
				</p>
				<hr />
				<div className={"d-flex justify-content-evenly flex-wrap align-items-center"} style={{rowGap: "8px"}}>
					<div className={"flex-grow-1"} style={{minWidth:"360px"}}>
						<div style={{width: 'fit-content', margin: '0 auto 0 0', textAlign: 'start'}}>
							<VSwitch
								key={ !! this.state.accepted }
								current={ !! this.state.accepted }
								items={ [
									{ value: true, label: Glob.label('ServiceTermsAccepted') },
									{ value: false, label: Glob.label('ServiceTermsRefused') },
								]}
								onChange={ x => { if (x?.label) this.acceptance( !! x.value ); }}
							/>
						</div>
					</div>
					<div
						style={{fontSize:"2.5rem",textAlign:"center",cursor:"pointer"}}
						className={"flex-grow-1"}
						onClick={ ()=>  { this.acceptance() } }
					>
						{ this.state.accepted ? '✅' : '⛔️' }
					</div>
					<div style={{width: 'fit-content'}}>
						<LanguageSwitcher notitle={true}/>
					</div>
				</div>
				<hr />
				<p lang={"it"}>
					Qui troviamo messaggi di offerta e ricerca.< br/>
					Quando inserite dei messaggi siate <strong>molto chiari</strong> su cosa viene offerto o cosa cercate, a che titolo (regalo, baratto o
					vendita), <strong>in che modo contattarvi</strong> e definite una data di scadenza dell'annuncio.<br />
					<strong>Nota:</strong> ricordate di eliminare gli annunci non più attuali.
				</p>
				<p lang={"en"}>
					Here read &amp; messages about searching and offering stuff.<br />
					When posting, be <strong>very clear</strong> about what's being offered or what you're looking for, in which way (e.g.: free, barter, or
					sale), <strong>how you'll be contacted</strong>, and set an expiration date for the ad.<br />
					<strong>Note:</strong> remember to delete no longer valid ads.
				</p>
				<Button
					color="success"
					disabled={!this.state.accepted}
					onClick={ ()=>{ Glob.setCurrentPageParam('pane','offro')}}
				>
					<i>
						<AppOffroIcon />
					</i>
					<b>
						<TextLabel value={"Offering"} />
					</b>
				</Button>
				<p lang={"en"}>
					Messages offering work services, initiatives, groceries and furniture, games, vehicles, offers or anything else.<br />
				</p>
				<p lang={"it"}>
					Messaggi per offerta di prestazioni lavorative, iniziative di vario tipo, elementi di arredo, giochi, veicoli, offerte o qualunque altra cosa.
				</p>
				<Button
					color="success"
					disabled={!this.state.accepted}
					onClick={ ()=>{ Glob.setCurrentPageParam('pane','cerco')}}
				>
					<i>
						<AppCercoIcon />
					</i>
					<b>
						<TextLabel value={"Wanted"} />
					</b>
				</Button>
				<p lang={"it"}>
					Messaggi per cercare prestazioni lavorative, collaborazioni o persone per iniziative di vario tipo,
					elementi di arredo, veicoli o qualunque altra cosa.
				</p>
				<p lang={"en"}>
					Messages from those looking for work services, initiatives, groceries and furniture, vehicles, or anything else.
				</p>
				<Button
					color="success"
					disabled={!this.state.accepted}
					onClick={ ()=>{ Glob.setCurrentPageParam('pane','user')}}
				>
					<i>
						<UserIcon />
					</i>
					<b>
						<TextLabel value={"Login"} />
					</b>
				</Button>
				<p lang={"it"}>
					Solo gli utenti autenticati possono inserire annunci.<br />
					Per autenticarsi è sufficiente confermare la propria email, con un codice usa e getta (OTP) che viene inviato al proprio indirizzo.
				</p>
				<p lang={"en"}>
					Only authenticated users can post ads.<br />
					To authenticate, simply confirm your email address with a one-time code (OTP) sent to your mailbox.
				</p>
				<hr />
				<h5 lang={"it"}>Termini di servizio</h5>
				<h5 lang={"en"}>Terms of Service</h5>
				<p lang={"it"}>
					Il servizio è amatoriale, del tutto gratuito e privo di pubblicità o altri introiti; si declinano ogni garanzia, supporto o responsabilità.
				</p>
				<p lang={"en"}>
					The service is provides “as-is”: amateur, completely free, and free of advertising or other revenue; we disclaim any warranties, support,
					or liability.
				</p>
				<p lang={"it"}>
					I termini accettati per utilizzare il servizio:
				</p>
				<p lang={"en"}>
					The terms you accept to use the service:
				</p>
				<ul>
					<li lang={"it"}>
						<strong>Privacy</strong>: il tuo indirizzo email come qualunque dato sensibile ad esso associato rimarrà strettamente legato all’operatività del servizio,
						non sarà ceduto a terzi né utilizzato al di fuori delle esigenze operative di gestione del servizio stesso.
					</li>
					<li lang={"en"}>
						<strong>Privacy</strong>: Your email address and any sensitive data associated with it will remain strictly linked to the operation of the service.
						It will not be disclosed to third parties or used outside of the operational needs of managing the service itself.
					</li>
					<li lang={"en"}>
						<strong>Language</strong>: despite of the fact that the interface is also available in English, this Noticeboard is mainly
						serving Italian people.<br />
						Please use Italian language, as soon as possible.
					</li>
					<li lang={"it"}>
						<strong>Cortesia e rispetto</strong> sono necessari per ogni interazione: cautela nello scrivere, elasticità nel leggere.
					</li>
					<li lang={"en"}>
						<strong>Courtesy and respect</strong> are necessary for every interaction: caution in writing, flexibility in reading.
					</li>
					<li lang={"it"}>
						<strong>Rimanere in argomento</strong>: sono accettati solo messaggi pertinenti, di tipo cerco/offro.<br />
						L’utente si impegna ad attenersi a questi argomenti, messaggi di natura diversa porteranno a interventi di moderazione.
					</li>
					<li lang={"en"}>
						<strong>Stay on topic</strong>: Only relevant, "wanted"/"offered" messages are accepted.<br />
						The user agrees to stick to these topics; messages of a different nature will be subject to moderation.
					</li>
					<li lang={"it"}>
						<strong>Limitazione di responsabilità</strong>: né il servizio né chi lo gestisce possono essere in alcun modo ritenuti responsabili
						per il contenuto o per la veridicità degli annunci inseriti dagli utenti.
					</li>
					<li lang={"en"}>
						<strong>Limitation of Liability</strong>: Neither the service nor its operators can be held responsible in any way
						for the content or accuracy of advertisements posted by users.
					</li>
					<li lang={"it"}>
						<strong>Moderazione</strong>: gli annunci inseriti sono soggetti a moderazione discrezionale ed insindacabile.<br/>
						Scopo della moderazione è mantenere un ambiente utile, pacifico e collaborativo.<br />
						Gli annunci potranno essere eliminati se considerati inopportuni, tali violazioni possono portare all’interdizione della mail associata,
						ovvero alla cancellazione degli annunci e all'interdizione dall’inserimento di annunci.<br />
						Le attività di moderazione non sono soggette a notifica né ad informazioni o motivazioni.<br />
						Con l’utilizzo del servizio l’attività di moderazione si intende sia implicitamente che espressamente accettata secondo tali modalità,
						nella sua natura discrezionale ed insindacabile.
					</li>
					<li lang={"en"}>
						<strong>Moderation</strong>: Posted ads are subject to discretionary and unquestionable moderation.<br/>
						The purpose of moderation is to provide a helpful, peaceful, and collaborative environment.<br />
						Posts may be removed if deemed inappropriate; inappropriate behaviors may result in the associated email account being banned,
						meaning the deletion of the ads and a ban on further ads.<br />
						Moderation activities are not subject to notification, information, or justification.<br />
						By using the service, moderation is both implicitly and expressly accepted according to these methods,
						in its discretionary and unquestionable nature.
					</li>
					<li lang={"it"}>
						<strong>Cancellazione dei dati</strong>: ogni utente che si autentica può autonomamente in qualunque momento cancellare tutti i dati
						che lo riguardano, rimuovendo dalla Bacheca tutti gli annunci collegati (pubblicati con tale utenza).
					</li>
					<li lang={"en"}>
						<strong>Deletion of data</strong>: Any authenticated user can independently delete their data at any time,
						also removing from the Noticeboard all associated ads as well (published under that account).
					</li>
					<li lang={"it"}>
						<strong>Accettazione dei temini di servizio</strong>: al fine di prevenire ed evitare problemi e discussioni, l’accesso al
						servizio di Bacheca collaborativa è soggetto all’accettazione esplicita dei suoi termini di servizio.<br />
						Chi per qualunque motivo non accettasse i termini di servizio, semplicemente non utilizzerà questa Bacheca.
					</li>
					<li lang={"en"}>
						<strong>Acceptance of Terms of Service</strong>: To prevent any complaints or problems, access to the Collaborative Noticeboard
						service is subject to explicit acceptance of the Terms of Service.<br />
						If for any reason you do not agree to the Terms of Service, please do not use this Noticeboard.
					</li>
				</ul>
				<hr />
			</div>
		)
	}
}

export default AboutBacheca;